import { Box, Grid, IconButton, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import useNoteContext from '../../hooks/useNoteContext/useNoteContext';
import useScreenShotContext from '../../hooks/useScreenShotContext/useScreenShotContext';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

import NoteIcon from '../../icons/NoteIcon';
import { useAppState } from '../../state';
import Snackbar from '../Snackbar/Snackbar';

type Status = 'ok' | 'nok';

export default function TopBar() {
  const { room } = useVideoContext();
  const [open, setOpen] = useState(false);

  const setStatus = async (status: Status) => {
    const endpoint = `${process.env.REACT_APP_TOKEN_ENDPOINT}/work-orders/call/status?room=${room?.name}`;

    const res = await fetch(endpoint, {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('portal_token'),
      },
      body: JSON.stringify({ status }),
    });

    if (res.status === 200) {
      setOpen(true);
      setTimeout(() => setOpen(false), 4000);
    }
  };

  const noteContext = useNoteContext();
  const screenShotContext = useScreenShotContext();

  useEffect(() => {
    noteContext.fetchNote();
    screenShotContext.fetchScreenShots();
  }, []);

  const { screenShots, openDrawer } = useScreenShotContext();

  const { setNoteDrawerOpen } = useNoteContext();

  const { role } = useAppState();

  if (role !== 'coordinator') return null;

  return (
    <>
      <Snackbar
        open={open}
        headline="Status updated successfully"
        message=""
        variant="info"
        handleClose={() => setOpen(false)}
      />
      <Box zIndex={9000} bgcolor="#fff" height={90}>
        <Grid container style={{ height: '100%', padding: '8px 0px' }} alignItems="center">
          <Grid item xs={2}>
            <Grid container alignItems="center">
              <Grid item xs={3}>
                <Box justifyContent="center" display="flex">
                  <IconButton
                    style={{ width: '60px', height: '60px', background: '#1E2E5E1A' }}
                    onClick={() => setNoteDrawerOpen(true)}
                  >
                    <NoteIcon />
                  </IconButton>
                </Box>
              </Grid>
              <Grid xs={1}>
                <Box justifyContent="center" display="flex">
                  <Box style={{ borderLeft: '1px solid #EAE9E9' }} height="50px" width="1px" />
                </Box>
              </Grid>
              <Grid xs={4}>
                <Box justifyContent="center" display="flex">
                  <IconButton
                    style={{ width: '60px', height: '60px', background: '#D4EEE0' }}
                    onClick={() => setStatus('ok')}
                  >
                    <Typography style={{ color: '#28C76F' }}>OK</Typography>
                  </IconButton>
                </Box>
              </Grid>
              <Grid xs={4}>
                <Box justifyContent="center" display="flex">
                  <IconButton
                    style={{ width: '60px', height: '60px', background: '#F3DBDB', borderColor: '#EA5455' }}
                    onClick={() => setStatus('nok')}
                  >
                    <Typography style={{ color: '#EA5455' }}>NOK</Typography>
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={9} style={{ height: '100%' }}>
            <Box display="flex" height="100%">
              <Box style={{ borderLeft: '1px solid #EAE9E9' }} height="100%" width="1px" />
              <Box px={4} py={1} display="flex" gridGap={4}>
                {screenShots.map(s => (
                  <Box key={s.id} onClick={() => openDrawer(s.id)} style={{ cursor: 'pointer' }}>
                    <img src={s.image} alt="screenshot" style={{ maxHeight: '100%', maxWidth: '120px' }} />
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
